// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._x3do18ew{border-top:var(--_m6cf7x)}._16jlidpf{flex-grow:0}\n._16qs4j53{box-shadow:var(--_cfawkn)}\n._1o9zidpf{flex-shrink:0}\n._i0dl1wug{flex-basis:auto}", ""]);
// Exports
module.exports = exports;
